import { ResumeTemplate } from '../../../types/resume';
import { MinimalTemplate } from './MinimalTemplate';
import { ProfessionalTemplate } from './ProfessionalTemplate';
import { ModernTemplate } from './ModernTemplate';
import { ChronoTemplate } from './ChronoTemplate';

export const templates: ResumeTemplate[] = [
  {
    id: 'minimal',
    name: 'Minimal',
    description: 'Clean and professional single-column layout',
    component: MinimalTemplate
  },
  {
    id: 'professional',
    name: 'Professional',
    description: 'Traditional two-column design with emphasis on experience',
    component: ProfessionalTemplate
  },
  {
    id: 'modern',
    name: 'Modern',
    description: 'Contemporary design with creative layout and typography',
    component: ModernTemplate
  },
  {
    id: 'chrono',
    name: 'Chronological',
    description: 'Timeline-based layout highlighting career progression',
    component: ChronoTemplate
  }
];

// Export individual templates for direct imports
export { MinimalTemplate } from './MinimalTemplate';
export { ProfessionalTemplate } from './ProfessionalTemplate';
export { ModernTemplate } from './ModernTemplate';
export { ChronoTemplate } from './ChronoTemplate';